import { roundValue, toDecimal } from "../../../../../util/decimal-utils";
import { getVariance, getUtilisationRate, getEffortCompletionPercentage } from "../../hours-calculation";

// Helper to calculate total hours from all stages (including nested) recursively
const calculateTotalProjectHours = (stagesList) => {
    let plannedEffort = toDecimal(0);
    let actualHours = toDecimal(0);

    // Sum top-level stages only, as children hours are already rolled up by calculateHoursRecursively
    stagesList.forEach(stage => {
        plannedEffort = plannedEffort.plus(toDecimal(stage.forecastHours || 0));
        actualHours = actualHours.plus(toDecimal(stage.actualHours || 0));
    });

    const variance = getVariance(actualHours.toNumber(), plannedEffort.toNumber());
    const utilisationRate = getUtilisationRate(actualHours.toNumber(), plannedEffort.toNumber());
    const effortCompletionPercentage = getEffortCompletionPercentage(actualHours.toNumber(), plannedEffort.toNumber());

    return {
        plannedEffort: plannedEffort.toNumber(),
        actualHours: actualHours.toNumber(),
        variance: roundValue(variance, 0),
        utilisationRate: roundValue(utilisationRate, 0),
        effortCompletionPercentageValue: effortCompletionPercentage,
        effortCompletionPercentage: `${effortCompletionPercentage.toFixed(2)}%`
    };
};

export default calculateTotalProjectHours;